import React from 'react'

// ui
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Avatar from '../../Avatar'
import { Dropdown } from './Dropdown'
import { Toggle } from './Toggle'
import { SearchBar } from './SearchBar'

// utils
import { concatStyles } from 'utils'
import { MouseEventHandler } from 'react'

export interface NavigatorHeadingProps {
  onToggleDrawer?: (active: boolean) => any
  onToggleProfile?: (active: boolean) => any
  appearance?: 'primary' | 'secondary'
  menuEnabled?: boolean
  searchEnabled?: boolean
  profileNavEnabled?: boolean
  sticky?: boolean
  drawerActive?: boolean
  profileActive?: boolean
  profileColor?: string
  profileName?: string
  profileImage?: string
  logo?: React.FC<any> | React.ComponentClass<any>
  profileNavigation?: React.FC<any> | React.ComponentClass<any>
  renderResults?: (onResultClick?: () => void) => JSX.Element | JSX.Element[]
  onSearchUpdate?: (s: string) => void
  onClickLogo?: () => void
}

const HEADER_STYLES = 'bg-contentareabackground border-b border-contentareaborder'
const NAVIGATOR_CLASS =
  'flex flex-row items-center p-0 h-[76px] flex-shrink-0 z-20 top-0'
const LOGO_CLASS = 'hidden sm:flex h-full items-center px-2 sm:px-3 lg:px-4 min-w-0'
const CLICKABLE_STYLES = 'cursor-pointer'
const PROFILE_NAV_CLASS = 'flex relative h-full items-center ml-2 mr-3 lg:mr-4'

/**
 * A reusable navigation header w/ search, profile, and primary navigation toggles.
 * @param param0 Props for this component.
 * @see NavigatorHeadingProps
 */
export const Navigator: React.FC<NavigatorHeadingProps> = ({
  profileNavigation: ProfileNavigation,
  drawerActive,
  profileActive,
  onSearchUpdate,
  renderResults,
  appearance = 'primary',
  logo: Logo,
  menuEnabled,
  searchEnabled,
  profileNavEnabled,
  onClickLogo: handleClickLogo,
  ...p
}) => {
  console.log('Navigator: Rendering with drawerActive =', drawerActive)

  const toggleDrawer = () => {
    console.log('Navigator: toggleDrawer called, current state =', drawerActive)
    if (p.onToggleDrawer) {
      console.log('Navigator: Calling onToggleDrawer with', !drawerActive)
      p.onToggleDrawer(!drawerActive)
    } else {
      console.log('Navigator: No onToggleDrawer provided!')
    }
  }

  const toggleProfile = () => {
    console.log(
      'Navigator: toggleProfile called, current state =',
      profileActive
    )
    if (p.onToggleProfile) {
      console.log('Navigator: Calling onToggleProfile with', !profileActive)
      p.onToggleProfile(!profileActive)
    } else {
      console.log('Navigator: No onToggleProfile provided!')
    }
  }

  const handleClick: MouseEventHandler = (e) => {
    e.preventDefault()
    if (handleClickLogo) {
      handleClickLogo()
    }
  }

  return (
    <div
      data-testid="app-top-nav"
      className={concatStyles([
        HEADER_STYLES,
        NAVIGATOR_CLASS,
      ])}
    >
      {menuEnabled ? (
        <Toggle onClick={toggleDrawer} active={drawerActive}>
          <FontAwesomeIcon icon={faBars} size="2x" />
        </Toggle>
      ) : null}
      {Logo ? (
        <div
          onClick={handleClick}
          className={concatStyles(
            LOGO_CLASS,
            handleClickLogo && CLICKABLE_STYLES
          )}
        >
          <Logo />
        </div>
      ) : null}
      {searchEnabled ? (
        <SearchBar
          onSearchUpdate={onSearchUpdate}
          renderResults={renderResults}
        />
      ) : null}
      <div className={PROFILE_NAV_CLASS}>
        {profileNavEnabled ? (
          <>
            <Toggle active={profileActive} onClick={toggleProfile}>
              {p.profileName || p.profileImage ? (
                <Avatar.Simple
                  name={p.profileName}
                  color={p.profileColor}
                  imageUrl={p.profileImage}
                  size={32}
                />
              ) : (
                <FontAwesomeIcon icon={faUser} size="2x" />
              )}
            </Toggle>
            {profileActive && ProfileNavigation ? (
              <Dropdown>
                <ProfileNavigation />
              </Dropdown>
            ) : (
              <span />
            )}
          </>
        ) : null}
      </div>
    </div>
  )
}
